import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
// import DatePicker from 'react-datepicker'; // Temporarily disabled
// import { isSameDay } from 'date-fns';//
import 'react-datepicker/dist/react-datepicker.css';
import './bookingForm.css';

const EMAILJS_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID!,
  bookingTemplateId: process.env.REACT_APP_EMAILJS_BOOKING_TEMPLATE_ID!,
  autoReplyTemplateId: process.env.REACT_APP_EMAILJS_AUTO_REPLY_TEMPLATE_ID!,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY!
};

const BookingForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const [bookingDate, setBookingDate] = useState<Date | null>(null);
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  // Optional unavailable dates
  /*const unavailablePeriods = [
    { start: new Date('2025-04-30'), end: new Date('2026-12-31') },
  ];
  const unavailableDates = [
    new Date('2025-03-22'),
    new Date('2025-03-23'),
    new Date('2025-03-24'),
    new Date('2025-03-25'),
    new Date('2025-03-26'),
    new Date('2025-03-27'),
    new Date('2025-04-05'),
    new Date('2025-04-06'),
  ];

  '/'
  /*const isDateAvailable = (date: Date) => {
    const inPeriod = unavailablePeriods.some(
      ({ start, end }) => date >= start && date <= end
    );
    if (inPeriod) return false;
    const inDates = unavailableDates.some(unavailableDate =>
      isSameDay(date, unavailableDate)
    );
    return !inDates;
  };
*/
  const sendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formRef.current) return;
    try {
      await emailjs.sendForm(
        EMAILJS_CONFIG.serviceId,
        EMAILJS_CONFIG.bookingTemplateId,
        formRef.current,
        EMAILJS_CONFIG.publicKey
      );

      await emailjs.sendForm(
        EMAILJS_CONFIG.serviceId,
        EMAILJS_CONFIG.autoReplyTemplateId,
        formRef.current,
        EMAILJS_CONFIG.publicKey
      );

      setSuccessMessage('Tack! Din bokning har skickats.');
      setErrorMessage('');
      formRef.current.reset();
      setBookingDate(null);

      setTimeout(() => setSuccessMessage(''), 5000);
    } catch (error) {
      console.error("Failed to send email", error);
      setErrorMessage('Ett fel uppstod. Försök igen senare.');
      setSuccessMessage('');
    }
  };

  return (
    <form ref={formRef} onSubmit={sendEmail} className="bookingForm">
      <div className="bookingForm__topSection">
        <section>
          <h3 className="h3-form">Namn</h3>
          <input type="text" name="name" placeholder="Namn" required className="bookingForm__input" />
        </section>
        <section>
          <h3 className="h3-form">Telefon</h3>
          <input type="number" name="telefon" placeholder="Telefon" required className="bookingForm__input" />
        </section>
        <section>
          <h3 className="h3-form">E-post</h3>
          <input type="email" name="user_email" placeholder="E-post" required className="bookingForm__input" />
        </section>
      </div>

      <div className="bookingForm__middleSection">
        <div className="bookingForm__columnLeft">
          <section>
            <h3 className="h3-form">Välj utrustningstyp</h3>
            <select name="equipment_type" required className="bookingForm__select">
              <option value="">Välj utrustning</option>
              <option value="Alpin">Alpin</option>
              <option value="Snowboard">Snowboard</option>
              <option value="Annat">Gäller annat</option>
            </select>
          </section>
          <section>
            <h3 className="h3-form">Välj servicenivå</h3>
            <select name="service_level" required className="bookingForm__select">
              <option value="">Välj servicenivå</option>
              {/*<option value="Vår500">Vår 500</option>*/}
              <option value="Enkel">Enkel</option>
              <option value="Avancerad">Avancerad</option>
              <option value="Expert">Expert</option>
              <option value="Fixa hål & repor">Fixa hål & repor</option>
              <option value="Bedömning">Bedömning</option>
            </select>
          </section>
        </div>

        <div className="bookingForm__columnRight">
          {/*<h3 className="h3-form">Välj datum</h3>

          
          <DatePicker
            inline
            selected={bookingDate}
            onChange={(date: Date | null) => setBookingDate(date)}
            filterDate={isDateAvailable}
            dateFormat="yyyy/MM/dd"
          />
          */}

          <input
            type="hidden"
            name="booking_date"
            value={bookingDate ? bookingDate.toISOString().split('T')[0] : ''}
          />
        </div>
      </div>

      <div className="bookingForm__bottomSection">
        <section>
          <h3 className="h3-form">Meddelande</h3>
          <textarea name="message" placeholder="Meddelande" className="bookingForm__textarea" />
        </section>
        <button type="submit" className="bookingForm__button">Skicka</button>
      </div>

      {successMessage && <p className="bookingForm__success">{successMessage}</p>}
      {errorMessage && <p className="bookingForm__error">{errorMessage}</p>}
    </form>
  );
};

export default BookingForm;

